/** The most dots the phone viewer shows at once. */
export const MAX_SLIDE_DOTS = 5;

export interface SlideDot {
    /** The slide this dot stands for. */
    slide: number;
    active: boolean;
    /** An end dot with more slides past it, drawn smaller to say so. */
    trailing: boolean;
}

/**
 * Which dots to draw for a set of slides: all of them while they fit, then a
 * window of {@link MAX_SLIDE_DOTS} that follows the current slide, its end
 * dots shrunk where there are more slides beyond them.
 */
export const slideDotsWindow = (count: number, current: number): SlideDot[] => {
    const shown = Math.min(count, MAX_SLIDE_DOTS);
    const half = Math.floor(MAX_SLIDE_DOTS / 2);
    const start = Math.min(Math.max(current - half, 0), count - shown);

    return Array.from({ length: shown }, (_, offset) => {
        const slide = start + offset;
        const moreBefore = offset === 0 && start > 0;
        const moreAfter = offset === shown - 1 && start + shown < count;
        return {
            slide,
            active: slide === current,
            trailing: slide !== current && (moreBefore || moreAfter),
        };
    });
};
